import { forwardRef, type Ref, type SVGProps } from "react";

function SvgMembershipLimitedColored(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 211 211" {...props}>
      <path
        fill="url(#membership_limited_colored_svg__a)"
        stroke="#FFB7B7"
        strokeWidth={7}
        d="M81.048 13.629c13.505-13.505 35.399-13.505 48.904 0l2.331 2.331a27.58 27.58 0 0 0 19.503 8.078h.595c19.098 0 34.581 15.482 34.581 34.581v.595c0 7.315 2.906 14.33 8.078 19.503l2.331 2.33c13.505 13.506 13.505 35.4 0 48.905l-2.331 2.331a27.58 27.58 0 0 0-8.078 19.503v.595c0 19.098-15.483 34.581-34.581 34.581h-.595a27.58 27.58 0 0 0-19.503 8.078l-2.331 2.331c-13.505 13.505-35.4 13.505-48.904 0l-2.331-2.331a27.58 27.58 0 0 0-19.503-8.078h-.595c-19.098 0-34.58-15.483-34.58-34.581v-.595a27.6 27.6 0 0 0-8.079-19.503l-2.331-2.331c-13.505-13.505-13.505-35.4 0-48.904l2.331-2.331a27.58 27.58 0 0 0 8.078-19.503v-.595c0-19.098 15.482-34.58 34.581-34.58h.595a27.6 27.6 0 0 0 19.503-8.079z"
      />
      <g clipPath="url(#membership_limited_colored_svg__b)">
        <path
          fill="#82090F"
          fillRule="evenodd"
          d="M91.54 70.419c6.412-10.37 21.494-10.37 27.906 0l27.858 45.046c6.759 10.93-1.103 25.035-13.954 25.035H77.635c-12.85 0-20.713-14.105-13.953-25.035zm13.96 17.58a3.28 3.28 0 0 1 3.281 3.282v17.5a3.281 3.281 0 0 1-6.562 0v-17.5A3.28 3.28 0 0 1 105.5 88m4.375 32.813a4.375 4.375 0 1 1-8.75 0 4.375 4.375 0 0 1 8.75 0"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <linearGradient
          id="membership_limited_colored_svg__a"
          x1={61.175}
          x2={105.5}
          y1={7}
          y2={204}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2E8" />
          <stop offset={1} stopColor="#F7D0D0" />
        </linearGradient>
        <clipPath id="membership_limited_colored_svg__b">
          <path fill="#fff" d="M53 53h105v105H53z" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgMembershipLimitedColored);
export default ForwardRef;
